/// <reference path="../wpt.ts" />
/*
    View with document dereferencing, set up for Polcies and Procedures.
    Expects to be launched without an inherited widget, from an AutoLunch widget on the home screen.
*/
var WPTNamespace;
(function (WPTNamespace) {
    var Navigation;
    (function (Navigation) {
        class DetailLayoutWorkflow extends Navigation.DetailLayoutBaseClass {
            constructor(typeName, core, handler, custom, context, readyCallback = null, secondaryActivationCallback = null) {
                super(typeName, core, handler, custom, context, readyCallback, secondaryActivationCallback);
                // Widgets
                this._queuesListWidget = null;
                this._basicQueueWidget = null;
                // Config at application level
                this._defaultDisplayColumns = [];
                this._noItemsPopup = false;
                this._autoSelectMode = WPTNamespace.Widgets.DocumentAutoSelectMode.NONE;
                this._autoListCollapse = "Hide";
                // Dereference handling
                this._dereferenceFormTypes = [];
                this._noItemsMessage = () => {
                    if (this._noItemsPopup) {
                        this._core.Helper.presentMessageModal(WPTNamespace.ModalType.FIRST, 'STR_WPT_NO_ACTIONS', 'STR_WPT_NO_ACTIONS_MESSAGE');
                    }
                };
                // Called when in receipt of an activation message, but layout is already the active one
                this.secondaryActivation = (context) => {
                    
                    if (context.ActivationType == Navigation.LayoutActivationType.WORKFLOW_NO_ITEMS) {
                        this._noItemsMessage();
                    }
                    super.secondaryActivation(context);
                };
                let appConfig = this._core.Config.getApplicationConfig();
                if (appConfig.hasOwnProperty("DetailViews")) {
                    let viewConfig = appConfig.DetailViews[this._name];
                    if (viewConfig != null) {
                        if (viewConfig.hasOwnProperty("DocumentReferenceForms") && (viewConfig.DocumentReferenceForms != null))
                            this._dereferenceFormTypes = viewConfig.DocumentReferenceForms;
                        if (viewConfig.hasOwnProperty("DefaultDisplayColumns"))
                            this._defaultDisplayColumns = viewConfig.DefaultDisplayColumns;
                        if (viewConfig.hasOwnProperty("NoItemsPopup"))
                            this._noItemsPopup = viewConfig.NoItemsPopup;
                        if (viewConfig.hasOwnProperty('AutoSelectMode'))
                            this._autoSelectMode = WPTNamespace.Widgets.DocumentAutoSelectMode[viewConfig.AutoSelectMode];
                        if (viewConfig.hasOwnProperty('CollapseListOnSelect'))
                            this._autoListCollapse = viewConfig.CollapseListOnSelect;
                    }
                }
            }
            _layoutInstancesActive() {
                
                // Check if we need this: will make widget transfer or non-queue activation tricky
                this._queuesListWidget = this._instancesByPlaceholder["queuesPlaceholder"];
                this._basicQueueWidget = this._instancesByPlaceholder["topTablePlaceholder"];
                this._basicQueueWidget.AutoSelectMode = this._autoSelectMode;
                if (this._defaultDisplayColumns.length > 0)
                    this._basicQueueWidget.setDisplayKeys(this._defaultDisplayColumns, false);
                if ((this._autoListCollapse == "Hide") || ((this._autoListCollapse == "Responsive") && (this._core.Helper.isNarrowDevice()))) {
                    this._basicQueueWidget.CollapseOnSelect = true;
                }
                // Convert old-style DV-based reference handling to widget-level conditional activation/slots
                if (this._basicQueueWidget) {
                    this._dereferenceFormTypes.forEach(docType => {
                        let dereference = {
                            Criteria: [{
                                    Type: 'DocType',
                                    Operator: 'Equal',
                                    Value: docType
                                }],
                            Slots: [WPTNamespace.Utilities.PRIMARY_SLOT_KEY, WPTNamespace.Utilities.WF_DRIVING_DOC_KEY],
                            FlexQuery: {
                                Type: 'byhandle',
                                Terms: [
                                    {
                                        Term: '>>handle',
                                        Value: '[[DOC_SLOT:[[PRIMARY]]]]:Document Handle',
                                        Operator: '='
                                    }
                                ]
                            },
                            ReferenceSlots: [WPTNamespace.Utilities.WF_USER_VIEW_DOC_KEY]
                        };
                        this._basicQueueWidget.ConditionalreferenceSelections.push(dereference);
                    });
                }
                this._status.setStatus(Navigation.LayoutInitialisationStatus.ACTIVE);
            }
            _postActivationActivity() {
                // Default overridden to add the "no items" message so we don't get that after secondary activation occurs
                
                this._stashedContext = this._context;
                // Invite all widgets to advertise their services and respond
                let advertContext = new Navigation.ActivationContext(null, Navigation.LayoutActivationType.REQUEST_TO_ADVERTISE);
                for (let widgetPointer in this._instancesByPlaceholder) {
                    this._instancesByPlaceholder[widgetPointer].activate(advertContext);
                }
                this._context = this._stashedContext;
                if (this._queuesListWidget && (this._queuesListWidget.getOriginatingLayout() != this._name) && (this._queuesListWidget.TotalItems == 0))
                    this._noItemsMessage();
                this.secondaryActivation(this._context);
            }
        }
        Navigation.DetailLayoutWorkflow = DetailLayoutWorkflow;
    })(Navigation = WPTNamespace.Navigation || (WPTNamespace.Navigation = {}));
})(WPTNamespace || (WPTNamespace = {}));
